import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsTransitFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_transit_filled"}/>
}
